import { useEffect, useState } from 'react'

import { NetworkStatus } from '@apollo/client'
import { ActionIcon, Divider, Input, Loader } from '@mantine/core'
import { useInView } from 'react-intersection-observer'

import { useParams } from '@redwoodjs/router'
import { useQuery } from '@redwoodjs/web'

import { GET_EMAIL_THREADS } from 'src/graphql/emails.graphql'
import IconFilter from 'src/icons/IconFilter'
import IconSearch from 'src/icons/IconSearch'
import EmailDetailsPage from 'src/pages/EmailDetailsPage/EmailDetailsPage'

import EmailCard from './EmailCard'

const EmailsTab = () => {
  const { id } = useParams()
  const [searchText, setSearchText] = useState('')
  const { ref, inView } = useInView({ threshold: 0 })

  const LIMIT = 10

  const { data, loading, fetchMore, networkStatus } = useQuery(
    GET_EMAIL_THREADS,
    {
      notifyOnNetworkStatusChange: true,
      variables: {
        input: {
          searchText,
        },
        pageInfo: { offset: 0, limit: LIMIT },
      },
    }
  )

  const emails = data?.getEmailThreads.items || []

  useEffect(() => {
    if (inView) {
      fetchMore({
        variables: {
          pageInfo: {
            offset: emails.length,
            limit: LIMIT,
          },
        },
      })
    }
  }, [inView])

  return (
    <div className="my-4 flex h-full flex-row gap-1 overflow-hidden ">
      <div className="flex w-[25%] flex-col gap-3">
        <div className="flex flex-row items-center justify-between text-lg font-medium">
          Sent Emails
          {/* <ActionIcon variant="subtle" color="gray">
            <IconFilter className="h-4 w-4 fill-none stroke-doubleNickel-gray-700" />
          </ActionIcon> */}
        </div>
        <Input
          placeholder="Search"
          variant="filled"
          value={searchText}
          onChange={(event) => setSearchText(event.target.value)}
          classNames={{
            input: 'bg-doubleNickel-gray-100',
          }}
          leftSection={
            <IconSearch className="h-3 w-3 fill-none stroke-doubleNickel-gray-700" />
          }
        />
        <Divider />
        <div className="flex h-full flex-col gap-4 overflow-y-auto">
          {loading && networkStatus !== NetworkStatus.fetchMore ? (
            <div className="flex h-full w-full items-center justify-center">
              <Loader color="gray" size="sm" />
            </div>
          ) : (
            <>
              {emails.length === 0 && (
                <div className="flex h-full w-full items-center justify-center text-sm text-doubleNickel-gray-500">
                  No emails found
                </div>
              )}
              {emails?.map((thread) => (
                <EmailCard key={thread.emailThreadId} email={thread} />
              ))}
              {networkStatus === NetworkStatus.fetchMore && (
                <Loader color="gray" size="sm" className="my-2 self-center" />
              )}
              {emails.length < (data?.getEmailThreads.totalCount || 0) && (
                <div ref={ref} className="opacity-0">
                  Inview placeholder
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <Divider orientation="vertical" />
      <div className="h-full w-full overflow-auto">
        {id && id !== 'emails' && <EmailDetailsPage />}
      </div>
    </div>
  )
}

export default EmailsTab
